import styled from 'styled-components'

export const ButtonsContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 1rem;

  .nohover:not(.fix-hover):hover {
    background-color: var(--button-background-color);
  }
`
